import React from "react";
import { useFirebase } from "../providers/firebase";

const Collaborations = () => {
    const { collaborations, collaborationsKeys } = useFirebase();
    return (
        <div className="collaborations-page-container">
            <div className="collaborations-heading">Collaborations</div>
            {collaborations ? (
                <div>
                    <div className="collaborations-content">
                        {collaborationsKeys.map((key, index) => {
                            const items = collaborations[key];
                            const heading = `${key}Links`;
                            const links = collaborations[heading];
                            if (Array.isArray(items) && items.length > 0) {
                                return (
                                    <div key={index}>
                                        <div className="line"></div>
                                        <h1 className="collaborations-type">
                                            {key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
                                        </h1>
                                        <div className="line"></div>
                                        <ul>
                                            {items.map((item, idx) => (
                                                <li className="collaborations-papers" key={idx}>
                                                    <div className="content">{idx + 1}.</div>
                                                    <div className="content">
                                                        <a href={links[idx]}>{item}</a>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div>
                </div>
            ) : (
                ""
            )}

            <div className="collaborations-copyright">
                &copy; All Rights Reserved by VSIMA Lab, SECS, IIT Bhubaneswar, 2024
            </div>
        </div>
    );
};

export default Collaborations;